/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Pagination_RowsInputs */

const es_billing_events_pagination_rows = /** @type {(inputs: Billing_Events_Pagination_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas`)
};

const en_billing_events_pagination_rows = /** @type {(inputs: Billing_Events_Pagination_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows`)
};

/**
* | output |
* | --- |
* | "Rows" |
*
* @param {Billing_Events_Pagination_RowsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_pagination_rows = /** @type {((inputs?: Billing_Events_Pagination_RowsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Pagination_RowsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_pagination_rows(inputs)
	return en_billing_events_pagination_rows(inputs)
});
export { billing_events_pagination_rows as "billing.events.pagination.rows" }